import i18next from 'i18next';

export const getCompositionLabel = (entity) => {
  if (!entity) {
    return i18next.t('GENERAL.NONE_VALUE');
  }

  return entity.isIngredient
    ? i18next.t('ADMIN.SUPPLIER_PRODUCTS.LIST_COLUMN_INGREDIENT')
    : i18next.t('GENERAL.RECIPE');
};

export const getChannelLabel = (entity, channel) => {
  if (entity.isIngredient || !entity.hasMultipleChannels) {
    return i18next.t('ADMIN.RECIPES.EXPORT_VALUE_SINGLE_CHANNEL');
  }

  return channel.translationKey ? i18next.t(`${channel.translationKey}.FULL`) : entity.channel;
};
